import { useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

import { getMapTilesConfigs } from "@/config/environmentUtils";

import { getTileUrl, isValidTileConfig } from "./map-tile.helper";

/**
 * MapTile component: adds a custom tile layer to the Google Map using global tile configuration.
 * The tile config is fetched internally and validated before adding the layer.
 */
const MapTile = () => {
  const map = useMap();
  const tilesInfo = getMapTilesConfigs();

  useEffect(() => {
    if (!map || !isValidTileConfig(tilesInfo)) {
      return;
    }

    const tileLayer = new google.maps.ImageMapType({
      getTileUrl: (coord, zoom) => {
        const url = getTileUrl({
          coord,
          zoom,
          tilesUrl: tilesInfo.tilesUrl!,
          tilesSize: Number(tilesInfo.tilesSize),
          tilesMaxZoom: Number(tilesInfo.tilesMaxZoom),
          tilesMinZoom: Number(tilesInfo.tilesMinZoom),
          tilesBottomLeftCoordinates: tilesInfo.tilesBottomLeftCoordinates!,
          tilesTopRightCoordinates: tilesInfo.tilesTopRightCoordinates!,
          map,
        });

        return url;
      },
      tileSize: new google.maps.Size(
        Number(tilesInfo.tilesSize),
        Number(tilesInfo.tilesSize)
      ),
      maxZoom: Number(tilesInfo.tilesMaxZoom),
      minZoom: Number(tilesInfo.tilesMinZoom),
      name: "CustomTiles",
    });

    map.overlayMapTypes.push(tileLayer);

    return () => {
      map.overlayMapTypes.removeAt(map.overlayMapTypes.getLength() - 1);
    };
  }, [map, tilesInfo]);

  return null;
};

export default MapTile;
